"use client";

import { useShallow } from "zustand/react/shallow";

import { useAuthStore } from "@/shared/model/auth-store";
import { useUserProfile } from "@/hooks/useAuth";
import {
  useLogin,
  useLogout,
  useRegister,
  useOAuthLogin,
  useOAuthUrl,
} from "@/hooks/useAuth";

export const useAuth = () => {
  const { isAuthenticated, isLoading } = useAuthStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      isLoading: state.isLoading,
    })),
  );
  const { data: user } = useUserProfile();
  const loginMutation = useLogin();
  const logoutMutation = useLogout();
  const registerMutation = useRegister();
  const oauthLoginMutation = useOAuthLogin();
  const oauthUrlMutation = useOAuthUrl();

  return {
    user: user ?? null,
    isAuthenticated,
    isLoading:
      isLoading || loginMutation.isPending || registerMutation.isPending,
    login: async (credentials: { username: string; password: string }) => {
      return loginMutation.mutateAsync(credentials);
    },
    logout: () => {
      logoutMutation.mutate();
    },
    register: async (data: {
      username: string;
      password: string;
      displayName?: string;
    }) => {
      return registerMutation.mutateAsync(data);
    },
    updateUser: () => {
      console.warn(
        "[useAuth] updateUser is deprecated, use useUpdateProfile hook instead",
      );
    },
    getUser: () => {
      console.warn(
        "[useAuth] getUser is deprecated, use useUserProfile hook instead",
      );
      return Promise.resolve(user ?? null);
    },
    oauthLogin: oauthLoginMutation.mutateAsync,
    getOAuthUrl: oauthUrlMutation.mutateAsync,
  };
};
